import './product-attributes.scss';

class CurrencySwitch {
    constructor (element) {
        this.$currencySwitch = element;
        this.$checkbox = this.$currencySwitch.querySelector('[data-currency-switch="checkbox"]');
        this.$toggle = this.$currencySwitch.querySelector('[data-currency-switch="toggle"]');
        this.$content = this.$currencySwitch.querySelector('[data-currency-switch="content"]');
    }

    initialize () {
        if (this.$toggle && this.$checkbox && this.$content) {
            this.$checkbox.onchange = () => {
                this.changeA11yLabelsByCheckbox();
            };

            this.$toggle.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    this.$checkbox.checked = !this.$checkbox.checked;
                    this.changeA11yLabelsByCheckbox();
                }

                if (event.code === 'Escape') {
                    event.preventDefault();
                    this.$checkbox.checked = false;
                    this.changeA11yLabelsByCheckbox();
                }
            });
        }
    }

    changeA11yLabelsByCheckbox () {
        if (this.$checkbox.checked) {
            this.$toggle.setAttribute('aria-expanded', 'true');
            this.$toggle.setAttribute('aria-checked', 'true');
            this.$content.setAttribute('aria-hidden', 'false');
        } else {
            this.$toggle.setAttribute('aria-expanded', 'false');
            this.$toggle.setAttribute('aria-checked', 'false');
            this.$content.setAttribute('aria-hidden', 'true');
        }
    }
}

export { CurrencySwitch };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $currencySwitch = $context.querySelector('[data-currency-switch="root"]');

        if ($currencySwitch) {
            const currencySwitch = new CurrencySwitch($currencySwitch);
            currencySwitch.initialize();
        }
    }
});
